export default "__VITE_ASSET__CIP5rO6L__"